/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GlobalUser } from '../models/GlobalUser';
import type { User } from '../models/User';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminUserService {

    /**
     * get list of users
     * @returns GlobalUser Success
     * @throws ApiError
     */
    public static getAdminUserList(): CancelablePromise<Array<GlobalUser>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/user',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get admin user
     * @returns User Success
     * @throws ApiError
     */
    public static getCurrentAdminUser(): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/user/current',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden - the caller is authenticated, but an access gate refuses this account; the body carries a machine-readable errorCode`,
                404: `The specified resource was not found`,
            },
        });
    }

}
